module.exports = __webpack_public_path__ + "img/recommendation-img@2x.e3796a4a.png";